export const TABLE_COLUMNS = [
  {
    Header: "Program Name",
    accessor: "program_name",
    width: 120,
  },
  {
    Header: "App",
    accessor: "app_type",
    width: 80,
  },
  {
    Header: "Subject",
    accessor: "email_subject",
    width: 100,
  },
  {
    Header: "Status",
    accessor: "status",
    width: 80,
  },
  {
    Header: "Receiver",
    accessor: "receiver",
    width: 100,
  },
  {
    Header: "Type",
    accessor: "email_type",
    width: 80,
  },
  {
    Header: "Recipient",
    accessor: "recipient_name",
    width: 100,
  },
  {
    Header: "Source",
    accessor: "email_source",
    width: 80,
  },
  {
    Header: "Email Template Id",
    accessor: "email_template",
    width: 120,
  },
  {
    Header: "Response",
    accessor: "response",
    width: 100,
  },
  {
    Header: "Created At",
    accessor: "created_at",
    width: 100,
  },
];
